<template>
  <div class="indexPage">
    <div class="list">
      <div class="item" v-if="dataItem != ''">
        <div class="block_one">
          <div class="column flex-rowl">
            <p class="label">创建时间：</p>
            <p class="con">{{ dataItem.order_time }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单状态：</p>
            <p class="con">
              {{
                dataItem.service_order_status == 1
                  ? "待接单"
                  : dataItem.service_order_status == 2
                  ? "已接单"
                  : dataItem.service_order_status == 3
                  ? "取餐中"
                  : dataItem.service_order_status == 4
                  ? "送餐中"
                  : dataItem.service_order_status == 5
                  ? "待自提"
                  : dataItem.service_order_status == 6
                  ? "已送达"
                  : "已完成"
              }}
            </p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单情况：</p>
            <p class="con">
              {{
                dataItem.service_order_property == 1
                  ? "服务订单进行中"
                  : dataItem.service_order_property == 2
                  ? "服务订单取消申请中"
                  : dataItem.service_order_property == 3
                  ? "服务订单已取消"
                  : "服务订单已完成"
              }}
            </p>
          </div>
        </div>

        <div class="block_two">
          <div class="column flex-rowl">
            <p class="label">服务订单号：</p>
            <p class="con">{{ dataItem.service_order_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单号：</p>
            <p class="con">{{ dataItem.order_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">送餐位置：</p>
            <p class="con">{{ dataItem.address_detail }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">关联取餐柜：</p>
            <p class="con">{{ dataItem.service_rating }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">用户姓名：</p>
            <p class="con">{{ dataItem.truename }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">联系电话：</p>
            <p class="con">{{ dataItem.customer_phone }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单内容：</p>
            <p class="con">{{ dataItem.order_content }}</p>
          </div>
        </div>

        <div class="block_three" v-if="dataItem.service_order_status >= 3">
          <div class="column flex-rowl">
            <p class="label">取餐员：</p>
            <p class="con">{{ pickupInfo.pickup_staff_name }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">取餐员工号：</p>
            <p class="con">{{ pickupInfo.pickup_staff_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">联系方式：</p>
            <p class="con">{{ pickupInfo.pickup_staff_contact }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">取餐时间：</p>
            <p class="con">{{ pickupInfo.pickup_time }}</p>
          </div>
        </div>

        <div class="block_three" v-if="dataItem.service_order_status > 4">
          <div class="column flex-rowl">
            <p class="label">送餐员：</p>
            <p class="con">{{ deliveryInfo.delivery_staff_name }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">送餐员工号：</p>
            <p class="con">{{ deliveryInfo.delivery_staff_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">联系方式：</p>
            <p class="con">{{ deliveryInfo.delivery_staff_contact }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">送餐时间：</p>
            <p class="con">{{ deliveryInfo.delivery_assignment_time }}</p>
          </div>
        </div>

        <div class="btn flex-rowr">
          <template v-if="dataItem.service_order_status == 3">
            <div class="primary-button" @click="handleQuery">进行送餐</div>
          </template>
          <template v-else-if="dataItem.service_order_status > 3">
            <div class="default-button">已进行送餐</div>
          </template>

          <!-- <div
            :class="deliveryInfo == '' ? 'primary-button' : 'default-button'"
            @click="handleQuery"
          >
            {{ deliveryInfo == "" ? "进行送餐" : "已进行送餐" }}
          </div> -->
        </div>
      </div>
      <van-empty
        description="该订单不存在"
        v-if="!isLoading && dataItem == ''"
      />
    </div>

    <div class="custom_btn" @click="handleReturn">返回</div>
  </div>
</template>
  
<script>
import { getOrderInfo, getSendMeal, getToken } from "../../api/api";
export default {
  name: "sMealIndex",
  data() {
    return {
      isRecive: false,
      isLoading: true,
      userInfo: "", // 用户信息
      dataItem: "", // 订单信息
      pickupInfo: "", // 取餐信息
      deliveryInfo: "", // 送餐信息
      order_id: "", // 订单id
      token: "", // token
    };
  },
  created() {
    let { id } = this.$route.params;
    this.order_id = id;
    this.token = this.$store.state.Authorization;
    this.userInfo = this.$store.state.USERINFO;
    this.getToken();
  },
  methods: {
    // 获取token
    getToken(isSubmit) {
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);

          if (isSubmit) {
            this.getSendMeal(res.data.token);
          } else {
            this.getOrderInfo(res.data.token);
          }
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 查看取餐订单
    getOrderInfo(token) {
      let { order_id } = this;
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getOrderInfo({ order_id, token }).then((res) => {
        if (res.error_code == 0) {
          if (
            Object.values(res.data).length != 0
            // &&
            // Object.values(res.data.pickup).length != 0
          ) {
            this.dataItem = res.data;
            this.pickupInfo = res.data.pickup;
            this.deliveryInfo =
              Object.values(res.data.delivery).length != 0
                ? res.data.delivery
                : "";
          } else {
            this.dataItem = "";
          }
          this.isLoading = false;
          toast.clear();
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
          this.isLoading = false;
          toast.clear();
        }
      });
    },

    handleQuery() {
      let { dataItem } = this;
      if (dataItem.service_order_status == "待接单") return;
      this.getToken(true);
    },

    getSendMeal(token) {
      let { order_id, userInfo, dataItem } = this;
      const toast = this.$toast.loading({
        message: "请稍后...",
        forbidClick: true,
      });
      let params = {
        order_id,
        token,
        delivery_staff_name: userInfo.truename,
        delivery_staff_id: userInfo.accountid,
        delivery_staff_contact: userInfo.mobile,
        current_location: dataItem.address_detail,
      };
      getSendMeal(params).then((res) => {
        if (res.error_code == 0) {
          toast.clear();
          this.$toast.success(res.message);
          setTimeout(() => {
            this.getOrderInfo(token);
          }, 500);
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  padding: 40px 0 300px;
  .list {
    .item {
      width: 660px;
      min-height: 700px;
      background: #ffffff;
      border: 6px solid #e6e6e6;
      border-radius: 40px;
      margin: 0 auto 30px;
      padding: 52px 44px 0;
      box-sizing: border-box;
      font-size: 28px;
      color: #040000;
      .block_one {
        font-size: 22px;
        margin-bottom: 65px;
        .column {
          .label {
            width: 140px;
          }
        }
      }
      .block_two {
        margin-bottom: 99px;
      }
      .block_three {
        margin-bottom: 85px;
      }
      .btn {
        margin-bottom: 60px;
      }
      .column {
        align-items: flex-start;
        &:nth-child(2n) {
          margin: 26px 0;
        }
        .label {
          white-space: nowrap;
          width: 190px;
          flex-shrink: 0;
        }
        .con {
          word-wrap: break-word;
          flex-shrink: 0;
          width: 380px;
        }
      }
    }
  }
}
</style>